import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { uploadModelProps } from '../../../types/reduxTypes/uploadModel';

const createReducer = <T extends SliceCaseReducers<uploadModelProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setUploadModelData(state, action) {
    state.uploadModelData = action.payload;
  },
  setUploadModelStatus(state, action) {
    state.uploadModelStatus = action.payload;
  }
});

export default reducers;
